/* eslint-disable react/jsx-boolean-value */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import CustomImage from "../../atoms/customImage";
import { formatToK } from "../../../utils/common/";
import { BEST_RATING } from "../../../constants/common/common";

/** */
const RateAndReview = ({
  review,
  isReviewTextHide = false,
  classes = "absolute left-8 z-1",
  isSmallReviewTag = false,
  isShowTotalReviews = true,
  isPriority = false,
  isSchema = true,
  isPadding = true,
  onReviewClickHandler = () => null,
  isProductListing = false,
  isTruncate = false,
}) => {
  const [width, setWidth] = useState(typeof window !== "undefined" ? window?.innerWidth : 0);

  /** */
  const returnWidthAndHeightForStar = () => {
    if (typeof window === "undefined") return;
    const resolution = window?.innerWidth;
    if (isProductListing) {
      if (resolution >= 1366 && resolution < 1920) {
        return 10;
      } else if (resolution >= 1920) {
        return 14;
      } else return isSmallReviewTag ? 7 : 10;
    }
    return isSmallReviewTag ? 7 : 10;
  };

  useEffect(() => {
    const getValue = returnWidthAndHeightForStar();
    setWidth(getValue);
  }, []);

  return (
    <div
      {...(isSchema && {
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "https://schema.org/AggregateRating",
        role: "presentation",
      })}
      className={`${classes} bottom-12 flex items-center gap-4 rounded-24 bg-white-900 bg-opacity-70 ${isPadding ? "px-10 py-4" : "p-0"} font-500 leading-0 text-fnp-500 ${isSmallReviewTag ? "text-10" : "text-12 xxl:text-14"} ${isTruncate ? "w-full min-w-0 max-w-full overflow-hidden" : "w-max"}`}
      onClick={onReviewClickHandler}
    >
      <CustomImage
        src="/icons/vector-rating.svg"
        width={width}
        height={width}
        alt="rating star"
        isPriority={isPriority}
      />
      <span
        className={`inter shrink-0 text-12 ${isProductListing ? "xxl:text-14" : ""} font-500 leading-4 text-fnp-500`}
        {...(isSchema && { itemProp: "ratingValue" })}
      >
        {review?.ratingValue}
      </span>
      {isShowTotalReviews && (
        <>
          <span className="h-[10px] w-[0.5px] shrink-0 bg-grey-200 md:h-[15px]" />{" "}
          <span {...(isSchema && { itemProp: "reviewCount" })} className="hidden">
            {review?.reviewCount ? review?.reviewCount : review?.ratingCount}
          </span>
          <span
            className={`inter min-w-0 text-12 font-500 leading-4 text-gray-500 ${isProductListing ? "xxl:text-14" : ""} ${isTruncate ? "truncate" : ""}`}
          >
            {review?.reviewCount
              ? formatToK(review?.reviewCount, isReviewTextHide)
              : formatToK(review?.ratingCount, isReviewTextHide)}
          </span>
        </>
      )}
      <div {...(isSchema && { itemProp: "bestRating" })} className="hidden">
        {BEST_RATING}
      </div>
    </div>
  );
};

RateAndReview.propTypes = {
  review: PropTypes.object.isRequired,
  isReviewTextHide: PropTypes.bool,
  classes: PropTypes.string,
  isSmallReviewTag: PropTypes.bool,
  isShowTotalReviews: PropTypes.bool,
  isPriority: PropTypes.bool,
  isSchema: PropTypes.bool,
  isPadding: PropTypes.bool,
  isProductListing: PropTypes.bool,
  isTruncate: PropTypes.bool,
  onReviewClickHandler: PropTypes.func,
};

export default RateAndReview;
